import { Box, Collapse, Fade, SxProps, Theme, useScrollTrigger } from "@mui/material";
import { FC, useEffect, useState } from "react";

export const bottomTrigger = (store: any, options: any) => {
    const { disableHysteresis = false, threshold = 100, target } = options;
    const previous = store.current;

    if (target) {
        // Get vertical scroll
        store.current = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
    }

    if (!disableHysteresis && previous !== undefined) {
        if (store.current < previous) {
            return false;
        }
    }



    return store.current < (document.scrollingElement?.scrollHeight ?? 0) - (document.scrollingElement?.clientHeight ?? 0) - threshold;
}

const ShowOnScroll: FC<{ window?: () => Window; children: React.ReactElement; sx?: SxProps<Theme>, getTrigger?: Function}> = ({
    children,
    window,
    sx,
    getTrigger
}) => {
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        target: window ? window() : undefined,
        getTrigger: getTrigger
    } as any);

    return (
        <Box sx={sx}>
            <Collapse in={trigger}>
                <Fade appear={false} in={trigger}>
                    {children}
                </Fade>
            </Collapse>
        </Box>
    );
}

export default ShowOnScroll;